import { useState } from "react";

import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const TextBoxCreateWithModal = (props) => {
    const [open, setOpen] = useState(false);
    const [value, setValue] = useState("");

    return (
        <>
            <Button variant="primary" onClick={() => setOpen(true)}>
                <FontAwesomeIcon icon={["fas", "plus-circle"]} /> เพิ่ม
            </Button>

            <Modal show={open} onHide={() => setOpen(false)} centered>
                <Modal.Header closeButton>{props.title ?? "เพิ่ม"}</Modal.Header>

                <Modal.Body>
                    <Form.Group>
                        <Form.Control type="email" value={value} onChange={(e) => setValue(e.target.value)} />
                    </Form.Group>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="light" onClick={() => setOpen(false)}>
                        ยกเลิก
                    </Button>
                    <Button
                        onClick={() => {
                            setOpen(false);
                            props.onCreate?.(value);
                        }}
                    >
                        ส่งข้อมูล
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default TextBoxCreateWithModal;
